export default (state) => ({
  ...state.users.meta,
  total: Number(state.users.meta.total),
  pages: Number(state.users.meta.pages),
})
